import angular from 'angular';
import MediaUsage from '../../MediaModules/MediaUsage';
import "./ImageSpinner.scss";

const imageSpinner = {
    bindings: {
        ngModel: '<',
    },
    template: require('./imageSpinner.html'),
    controller: function ($scope, $timeout) {

        const SHOW_SPINNER_DELAY = 500;

        this.pending = false;

        this.$onChanges = () => {

            if (!this.ngModel || !this.ngModel.length) {
                return;
            }

            let delay = $timeout(() => {
                this.pending = true;
            }, SHOW_SPINNER_DELAY);

            let url = new MediaUsage(this.ngModel[0].media, 1920, 0).getImgUrl();

            let img = new Image();

            img.onload = () => {
                this.pending = false;
                $timeout.cancel(delay);

                if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                    $scope.$apply();
                }

            };

            img.src = url;

            if (img.complete) img.onload();
        }
    }
};

export default angular.module('cms.creator.imageSpinner', [])
    .component('cmsCreatorImageSpinner', imageSpinner).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ImageSpinner/ImageSpinner.js